/*******************************************************************************
 * Project:
 * Summary:
 *      Define EnterKeyService class
 * Remarks:
 *      Define EnterKeyService
 * History:
 *      NguyenTV            2021/07/01    Create
 ******************************************************************************/
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class EnterKeyService {
    selectedInput: BehaviorSubject<EnterKey> = new BehaviorSubject<EnterKey>(new EnterKey());
}

export class EnterKey{
    idx = 1;
    blnIsShift = false;
}
